import React from 'react'
import { getImages } from '../components/Common/const'
const reviewList = [
    {
        name: 'Carlos Landaeta Q',
        posttime: 'a week ago',
        content: `<p>I had a wonderful experience buying my car, and I couldn't be more grateful for the support I received. From the moment I first saw the car, Chandler was incredibly professional and attentive. He guided me through every step of the financial process and made the delivery seamless. They truly made the entire experience easy and stress-free, and I appreciate all their efforts!</p>`,
    },
    {
        name: 'L Portugal',
        posttime: '5 months ago',
        content: `<p>Excellent Service! Thank you Mario & Steven for making my Lamborghini transaction super fast! Highly recommend Mark Motors for their wide selection of exotic vehicles. Couldn’t be happier with my selection.</p>`,
    },
    {
        name: 'John',
        posttime: '8 months ago',
        content: `
        <p>I recently had my Cyber Truck wrapped and windows tinted at Mark Motors, and I couldn't be happier with the results! The team was incredibly efficient and took the time to explain every detail of the process, ensuring I was informed and comfortable throughout.</p>
        <p>The quality of the completed work was flawless—from the wrap to the window tinting, everything looks amazing. Not only did they surpass my expectations in terms of craftsmanship, but their customer service was also outstanding. They truly went above and beyond to make sure I was satisfied.</p>
        <p>I highly recommend Mark Motors for anyone looking to customize their vehicle. You won't be disappointed!</p>
        <p>Jeff M<br/>Fredericksburg, Texas</p>`,
    },
    {
        name: 'Andrew Hernandez',
        posttime: '4 months ago',
        content: `<p>This is my 2nd deal with MM in 8 months. Not sure how or where these 1 star reviews are coming from, but I'm thinking there are accountability issues with those individuals. My boy Nathan got me hooked up with this beast G550 4x4. From the initial text to source the vehicle, to delivery took less than a month. Paperwork took less than 15min with Steve. Everything again was upfront and transparent. There was an issue with a leaky shock after delivery, which is inevitable for a 7 year old car with 10k miles. One text and 30min later and the issue is being taken care of with white glove service. For anyone, especially those buying out of town, you can buy with confidence when buying with these guys.</p>`,
    },
    {
        name: 'JOANNA GROSHANS',
        posttime: '5 months ago',
        content: `<p>We have bought and sold several cars with Nathan at Mark's Motors. Excellent customer service and their vehicles are always top tier. From start to finish it is seamless.<br/>
Thank you for what you offer your customers.<br/>
100% recommend.</p>`,
    },
    {
        name: 'Alex ASF Trans',
        posttime: 'a month ago',
        content: `<p>It's easy to choose a two-door friend for yourself! High professionals! Respect! Recommend!</p>`,
    },
    {
        name: 'Jessica Norcross',
        posttime: '2 years ago',
        content: `<p>Absolutely love Mark Motors! In a difficult market, Gerardo searched high and low to find me a new car. Justin w/Mark Customs took my new, ordinary Escalade and turned it into my dream car. It’s gorgeous and exactly what I was hoping for! Their Customer Service is top notch and my family and I plan to be life-long customers.</p>`,
    },
    {
        name: 'Donovan Greenlee',
        posttime: 'a year ago',
        content: `<p>My review goes out to the Mark Motors Customs' team (Jennifer, Justin, Kirk, and others). The customs team has performed several jobs on my C8 corvette. They have installed tints, a carbon fiber rear spoiler, installed aftermarket wheels, and recently repaired my paint after it sustained heavy rock chip damage (over 40 chips in the paint). Each job they have performed, was done at a phenomenal level. Even Chevrolet told me that they themselves wouldn't be able to repair the damage completely and that the chips would still be noticeable. The Customs team at Mark Motors did beyond that and repaired the paint to 110 percent. Nothing from the rock chips remained. The bumper looks completely brand new. The PPF they installed afterward is also barely noticeable. I could barely make out the edges of the PPF because of how close they got it to the perimeter of my front bumper. Big thanks to the team for their work and their communication with me throughout the days of service.</p>`,
    },
    {
        name: 'Paul Zakhary',
        posttime: '6 months ago',
        content: `<p>I had a fantastic experience at Mark Motors. Nathan was top notch and was very easy to work with while purchasing my 992 GT3.  From the car locating, paperwork and front door delivery, it was one of my smoothest transactions I’ve ever experienced.</p>

<p>The Mark Motors Team are all extremely professional and very transparent about their cars and pricing. Highly recommend both Mark Motors and Nathan as a contact.  Definitely not the last time I will be purchasing a car from them and happy to be part of the Mark Motors Family.</p>`,
    },
    {
        name: 'Buckalew',
        posttime: '2 years ago',
        content: `<p>What can I say……. These guys are the BEST!!  I have bought a lot of cars and the team at Mark Motors is the Best!! They have gone ABOVE and BEYOND!! I highly recommend!! Mario Addari in sales took his time and NO PRESSURE.  He knows his stuff!! Steven Partida in finance was great, I was in and out!! And Craig Ryals got my car delivered to my house perfectly!!!! Thank you soooooo much!!!</p>`,
    },
    {
        name: 'Chet',
        posttime: 'a month ago',
        content: `<p>Love Mark Motors - 5 star review for annual service, loaner drop off, pick up, service done right with a smile. Thank you Andres, Robert, service team for a hassle free experience.</p>`,
    },
    {
        name: 'Ash Longer',
        posttime: '3 years ago',
        content: `<p>Amazing dealership, Purchased a car from them, had some issues which they offered to fix themselves , then realized repairs would take quite a while so they traded me out in a Mclaren 600LT. Couldn't be more pleased with them as a company and Nathan who was my salesman was amazing and very communicative throughout the whole process. Would HIGHLY RECOMMEND.</p>`,
    },
    {
        name: 'Drew Baker',
        posttime: '6 months ago',
        content: `<p>Cody at Mark Motors is the best in the business. We’ve done many many deals and they’ve always been more than smooth. Even though we’ve never met, I know I can trust MM and Cody with large transactions sight unseen. Don’t hesitate to do business with them!</p>`,
    },
    {
        name: 'Bob M',
        posttime: 'a month ago',
        content: `<p>A lot of beautiful cars! Staff is very polite and highly professional!</p>`,
    },
    {
        name: 'Andrey T',
        posttime: '3 months ago',
        content: `<p>Great customer service, car selection is pretty nice and the facility size and tidiness is great!</p>`,
    },
    {
        name: 'Z Abouhamzeh',
        posttime: 'a month ago',
        content: `<p>Daniel Johnson is a true professional and I definitely recommend you work with him. Called him to get a buy bid on a Lamborghini Huracan and he was as honest and straightforward as one can be! Call and ask for Daniel Johnson!</p>`,
    },
    {
        name: 'Dr William Parker MD FACS',
        posttime: 'a year ago',
        content: `<p>So last year I gave Mark Motors 5 stars ! I’m back buying another car from them and I have had the best car buying experience I’ve ever had!<br/>
Gerardo is amazing. Low pressure and excellent in every way.<br/>
I traded my NSX in for essentially what I paid for it a year ago.<br/>
I’ll be back !</p>`,
    },
    {
        name: 'Mike Mo',
        posttime: 'a year ago',
        content: `<p>Awesome car dealer.  Excellent buying experience from across the country.  Almost too easy.  Mario, Steven, and Cody set me up and got me my wheels and couldn’t be happier.  Thx !!!!!</p>`,
    },
    {
        name: 'Chris Allahyar',
        posttime: 'a year ago',
        content: `<p>Been working with Devin at Marks Motors for a while . Getting my trade in and buying my dream car was just absolutely great . Been buying a lot of cars and Never had such great experience with dealership or sales team . They guys are the best !! From the start to finish . Thank you , thank you</p>`,
    },
    {
        name: 'Mark Gibson',
        posttime: '5 years ago',
        content: `<p>Excellent Service. My wife was in search of a Good Dealer to trade in her Lamborghini Gallardo for a Huracan. We had contacted several dealers, but Mark Motors were the most sincere and honest. Everything was done by phone text and email before we arrived. Devin Heller, our sales person, was knowledgeable and professional. No pressure just a Great business attitude. The other dealers we contacted only contacted us once and that was it..  "Crazy" Huh. When we arrived, Steven, the finance manager, had all the paperwork ready and we were in and out within 45 minutes. I highly recommend this dealer for any vehicle purchase. The professionalism and the atmosphere is OVER THE TOP!!!!  Mg</p>`,
    },
]
const CustomerReviews = () => {
    console.log("reviewList", reviewList.length)
    return (
        <>
            <section className='common-banner-wrap position-relative add-shadow'>
                <img src={getImages('customer-reviews-bg.jpg')} />
                <div className='cb-pos'>
                    <div className='xl-title text-uppercase wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.4s">Customer Reviews</div>
                </div>
            </section>
            <section className='cr-wrap'>
                <div className='container mxw-1230'>
                    {/* <div className='row align-items-center'>
                        <div className='col-lg-6 wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.3s">
                            <div className='cr-box testimonial-box'>
                                <div className='sm-title fw-bold'>307 Testimonials</div>
                                <div className='d-flex align-items-center mb-3'>
                                    <div className='rating-star me-3'>
                                        <span><i className="bi bi-star-fill"></i></span>
                                        <span><i className="bi bi-star-fill"></i></span>
                                        <span><i className="bi bi-star-fill"></i></span>
                                        <span><i className="bi bi-star-fill"></i></span>
                                        <span><i className="bi bi-star-fill"></i></span>
                                    </div>
                                    <div className='xs-title opacity-0-5 font-12 text-uppercase'>5 out 5 stars</div>
                                </div>
                                <div className='d-flex align-items-center mt-2'>
                                    <div className='xs-title fw-500 text-blue w-50px'>5 Star</div>
                                    <div className="progress cr-progress" role="progressbar" aria-label="Default striped example" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100">
                                        <div className="progress-bar" style={{ width: "100%" }}></div>
                                    </div>
                                    <div className='xs-title fw-500'>299</div>
                                </div>
                                <div className='d-flex align-items-center mt-2'>
                                    <div className='xs-title fw-500 text-blue w-50px'>4 Star</div>
                                    <div className="progress cr-progress" role="progressbar" aria-label="Default striped example" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100">
                                        <div className="progress-bar" style={{ width: "2%" }}></div>
                                    </div>
                                    <div className='xs-title fw-500'>2</div>
                                </div>
                                <div className='d-flex align-items-center mt-2'>
                                    <div className='xs-title fw-500 text-blue w-50px'>3 Star</div>
                                    <div className="progress cr-progress" role="progressbar" aria-label="Default striped example" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
                                        <div className="progress-bar" style={{ width: "1%" }}></div>
                                    </div>
                                    <div className='xs-title fw-500'>1</div>
                                </div>
                                <div className='d-flex align-items-center mt-2'>
                                    <div className='xs-title fw-500 text-blue w-50px'>2 Star</div>
                                    <div className="progress cr-progress" role="progressbar" aria-label="Default striped example" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
                                        <div className="progress-bar" style={{ width: "1%" }}></div>
                                    </div>
                                    <div className='xs-title fw-500'>1</div>
                                </div>
                                <div className='d-flex align-items-center mt-2'>
                                    <div className='xs-title fw-500 text-blue w-50px'>1 Star</div>
                                    <div className="progress cr-progress" role="progressbar" aria-label="Default striped example" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100">
                                        <div className="progress-bar" style={{ width: "4%" }}></div>
                                    </div>
                                    <div className='xs-title fw-500'>4</div>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-6 text-end d-none d-lg-block wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.6s">
                            <img src={getImages('mm-logo-white.png')} />
                        </div>
                    </div> */}
                    {/* <div className='d-flex align-items-center justify-content-between'>
                    <div>
                        <select className='form-control filter-sort-select'>
                            <option>Most Recent</option>
                        </select>
                    </div>
                    <div>
                        <select className='form-control filter-sort-select'>
                            <option>All Sources</option>
                        </select>
                    </div>
                </div> */}
                    <div className='pt-md-4'>
                        {reviewList.map((item, index) => (
                            <>
                                <div className='cr-box mt-4 crl-box wow fadeInUp' data-wow-duration="1s" data-wow-delay="0.3s" key={index}>
                                    <div className='d-flex align-items-center justify-content-between mb-2'>
                                        <div>
                                            <div className='sm-title fw-bold'>{item.name}</div>
                                            <div className='d-flex align-items-center flex-wrap'>
                                                <div className='rating-star me-3'>
                                                    <span><i className="bi bi-star-fill"></i></span>
                                                    <span><i className="bi bi-star-fill"></i></span>
                                                    <span><i className="bi bi-star-fill"></i></span>
                                                    <span><i className="bi bi-star-fill"></i></span>
                                                    <span><i className="bi bi-star-fill"></i></span>
                                                </div>
                                                <div className='xs-title opacity-0-5 font-12 fw-500 text-uppercase'>{item.posttime}</div>
                                            </div>
                                        </div>
                                        <div>
                                            <div className='cr-box-image'>
                                                <img src={getImages('google.png')} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className='cr-content mb-3' dangerouslySetInnerHTML={{ __html: item.content }} />
                                </div>
                            </>
                        ))}
                    </div>
                    <div className='text-center d-lg-none pt-5 mm-logo'>
                        <img src={getImages('mm-logo-white.png')} />
                    </div>
                </div>
            </section>
        </>
    )
}

export default CustomerReviews